import { render, staticRenderFns } from "./HomeValueTile.vue?vue&type=template&id=71922197"
import script from "./HomeValueTile.vue?vue&type=script&lang=js"
export * from "./HomeValueTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../config/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports